import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { ApiKey } from '@/types/user';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  keyId: string;
};

export const getApiKeyDetails = async (
  scope: RequestScope,
  { keyId }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<ApiKey>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<ApiKey>>(`/organization/client/${keyId}`, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error);
  }
};
